import copy from '@/data/translations/ro/valuation.json';

export const valuationFaqs = [
  { q: copy.inputs_question, a: copy.inputs_answer },
  { q: copy.selling_question, a: copy.selling_answer },
  { q: copy.no_estimate_question, a: copy.no_estimate_answer },
  { q: copy.buyback_question, a: copy.buyback_answer },
  { q: copy.free_question, a: copy.free_answer },
  { q: copy.updates_question, a: copy.updates_answer },
];

export function valuationFaqSchema() {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: valuationFaqs.map(({ q, a }) => ({
      '@type': 'Question', name: q,
      acceptedAnswer: { '@type': 'Answer', text: a },
    })),
  };
}

// Representative inputs, not a stored estimate. All displayed results come from the RPC.
export const valuationExampleInput = { make: 'BMW', model: 'Seria 4', year: 2023, mileage: 68700, brandSlug: 'bmw' };
export interface ValuationExample {
  make: string; model: string; year: number; mileage: number; brandSlug: string;
  low: number; high: number; median: number; count: number;
  yearMin: number; yearMax: number;
}

export function parseValuationExample(value: unknown): ValuationExample | null {
  if (!value || typeof value !== 'object') return null;
  const r = value as Record<string, unknown>;
  const years = r.year_range as { min?: unknown; max?: unknown } | undefined;
  if (r.has_data !== true || typeof r.comparables_count !== 'number' || r.comparables_count < 3
    || typeof r.estimated_low !== 'number' || typeof r.estimated_high !== 'number'
    || typeof r.median_market_price !== 'number' || typeof years?.min !== 'number'
    || typeof years?.max !== 'number') return null;
  return { ...valuationExampleInput, low: r.estimated_low, high: r.estimated_high,
    median: r.median_market_price, count: r.comparables_count, yearMin: years.min, yearMax: years.max };
}